<template>
  <svg :width="`${size}px`" :height="`${size}px`">
    <circle :cx="size/2" :cy="size/2" :fill="fill" :r="size/2"/>
  </svg>
</template>

<script>
/** Use the `Circle` component for creating a filled circle with the given diameter and color. */
export default {
  name: 'finCircle',
  props: {
    /** the diameter of the circle */
    size: {
      type: Number,
      default: 50
    },
    /** the color the circle is getting filled with */
    fill: {
      type: String,
      default () {
        return this.$finColors.primaryDark
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  svg {
    -webkit-filter: drop-shadow(-2px 2px 8px rgba(0, 0, 0, 0.1));
    filter: drop-shadow(-2px 2px 8px rgba(0, 0, 0, 0.1));
  }
</style>
